<template>
  <div class="signup-step">
    <span class="eyebrow">{{ t('step1_eyebrow') }}</span>
    <h2>
      {{ t('step1_title_prefix') }}<span class="grad">{{ t('step1_title_grad') }}</span>{{ t('step1_title_suffix') }}
    </h2>
    <p class="sub">
      {{ t('step1_sub_prefix') }}<strong>{{ t('step1_sub_strong') }}</strong
      >{{ t('step1_sub_suffix') }}
    </p>

    <SocialButtons
      label-key-prefix="social"
      intent="register"
    />

    <div class="divider-or">
      <em>{{ t('divider_dob') }}</em>
    </div>

    <span class="field-label">{{ t('lbl_dob') }}</span>
    <div
      class="dob-row"
      role="group"
      :aria-label="t('lbl_dob')"
    >
      <input
        ref="day"
        :value="day"
        type="text"
        class="signup-input"
        :placeholder="t('ph_day')"
        maxlength="2"
        inputmode="numeric"
        autocomplete="off"
        :aria-label="t('aria_day')"
        @input="onInput($event, 'day', 'month')"
      />
      <input
        ref="month"
        :value="month"
        type="text"
        class="signup-input"
        :placeholder="t('ph_month')"
        maxlength="2"
        inputmode="numeric"
        autocomplete="off"
        :aria-label="t('aria_month')"
        @input="onInput($event, 'month', 'year')"
      />
      <input
        ref="year"
        :value="year"
        type="text"
        class="signup-input"
        :placeholder="t('ph_year')"
        maxlength="4"
        inputmode="numeric"
        autocomplete="off"
        :aria-label="t('aria_year')"
        @input="onInput($event, 'year', null)"
      />
    </div>
    <div
      class="age-hint"
      :class="{ ok: ageHint.ok, bad: ageHint.bad }"
    >
      <icon-info-circle
        :size="14"
        :stroke-width="2"
      />
      <span>{{ ageHint.text }}</span>
    </div>

    <p class="terms">
      {{ t('terms_prefix') }}
      <a
        href="/agb"
        target="_blank"
        rel="noopener"
        >{{ t('terms_link_agb') }}</a
      >{{ t('terms_middle') }}
      <a
        href="/datenschutz"
        target="_blank"
        rel="noopener"
        >{{ t('terms_link_privacy') }}</a
      >{{ t('terms_suffix') }}
    </p>
  </div>
</template>

<script>
import { i18nMixin, getAgeHint } from '../helpers';
import SocialButtons from './SocialButtons.vue';
import IconInfoCircle from '../../icons/IconInfoCircle.vue';

export default {
  name: 'BirthdayStep',
  mixins: [i18nMixin],
  components: {
    SocialButtons,
    IconInfoCircle,
  },
  props: {
    day: { type: String, default: '' },
    month: { type: String, default: '' },
    year: { type: String, default: '' },
  },
  computed: {
    // Mirrors viluu-site/viluu-signup.js updateAgeDisplay() — helper text below
    // the DOB inputs. Pure function of the three props.
    ageHint() {
      return getAgeHint(
        { day: this.day, month: this.month, year: this.year },
        (key) => this.t(key),
      );
    },
  },
  methods: {
    // Strip non-digits, push the value up to the parent, then auto-advance focus
    // to the next field once this one is full. We keep the input's DOM value in
    // sync ourselves so a rejected character never lingers when the cleaned
    // value happens to equal the current prop.
    onInput(event, field, nextField) {
      const val = event.target.value.replace(/\D/g, '');
      if (event.target.value !== val) {
        event.target.value = val;
      }
      this.$emit('update:' + field, val);
      const maxLen = field === 'year' ? 4 : 2;
      if (val.length >= maxLen && nextField && this.$refs[nextField]) {
        this.$refs[nextField].focus();
      }
    },
  },
};
</script>
